import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { useLocation } from '@reach/router';
import { Disclosure } from '@headlessui/react';
import {
  CheckCircleIcon,
  ChevronDownIcon,
} from '@heroicons/react/24/solid';

import { RadioIcon } from '../../Elements';


const Menu = ({
  allowScroll,
  childCategories,
  topCategoryItem,
}) => {

  const location = useLocation();
  // Construct a path for all but the final category in the URL.
  // This will be used to determine which category to open in the menu, if any.
  // converts '#/top/category/form/' to '/top/category/'
  const _path = location.hash
    .slice(1)
    .split('/')
    .filter((el) => el)
    .slice(0, -1)
    .join('/');
  const path = `/${_path}/`


  // Disclosure panel state management.
  // https://stackoverflow.com/a/76230280
  const [activeDisclosurePanel, setActiveDisclosurePanel] = useState(null);

  const initialPanelRef = useRef(null);

  // Disclosure panel state management.
  function togglePanels(newPanel) {

    // if the initial panel ref is set, send it a click event
    if (initialPanelRef.current) {
      initialPanelRef.current.click();
      initialPanelRef.current = null;
    }

    if (activeDisclosurePanel) {
      if (activeDisclosurePanel.key !== newPanel.key && activeDisclosurePanel.open) {
        activeDisclosurePanel.close();
      }
    }
    setActiveDisclosurePanel({
      ...newPanel,
      open: !newPanel.open
    });
  }

  return (
    <div className="max-w-7xl mx-auto">
      <div className="prose prose-custom mx-auto">
        {topCategoryItem?.label
          && (
            <h3>{topCategoryItem.label}</h3>
          )}
        <p>
          <strong>Please fill out the form to request a quote. If you would prefer to discuss the details over the phone, simply provide your contact information. </strong>
        </p>

        {childCategories.length > 0 && topCategoryItem.label !== 'Complete Signage Solutions'
          && (
            <>
              <p className="font-bold text-md">Please select a product:</p>
              {childCategories.map(({ node }, i) => {
                // Iterate through the next level of categories and display them.
                if (node.parentUid == topCategoryItem.uid) {
                  // Find the children of this category.
                  const children = childCategories.filter((item) => item.node.parentUid === node.uid);
                  if (children.length > 0) {
                    const refProps = node.path === path ? { ref: initialPanelRef } : {}; 

                    return (
                      <Disclosure key={`categories-${node.uid}`} defaultOpen={node.path === path}>
                        {
                          (panel) => {
                            const { open, close } = panel;
                            return (
                              <>
                                <Disclosure.Button
                                  open
                                  onClick={() => {
                                    if (!open) {
                                      close();
                                    }
                                    togglePanels({ ...panel, key: i });
                                  }}
                                  className={`text-sm mb-1 block w-full text-left p-1 px-3 bg-light-gray-100 ${open ? ' bg-light-gray-300 ui-font-bold' : ''}`}
                                  {...refProps}
                                >
                                  <div className="flex items-center">
                                    <div className="flex items-center justify-between w-full">

                                      <span><a href={`#${node.path.slice(1)}`} className="no-underline">{node.label}</a></span><ChevronDownIcon className="w-4 h-4" />

                                    </div>
                                  </div>
                                </Disclosure.Button>
                                <Disclosure.Panel>
                                  <ul>
                                    {children.map(({ node }, j) => (
                                      <li className="list-none" key={`categories-${node.uid}`}>
                                        <div className="flex items-center">

                                          <RadioIcon
                                            className={`inline mr-1`}
                                            aria-hidden="true" 
                                            checked={location.hash.slice(1) === node.path.slice(1)}
                                          />

                                          <a href={`#${node.path.slice(1)}`} onClick={allowScroll}>{node.label}</a>
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                </Disclosure.Panel>
                              </>
                            );
                          }
                        }
                      </Disclosure>
                    );
              } else {
                return (
                  <div key={`categories-${node.uid}`} className="text-sm mb-1 block w-full text-left p-1 px-3 bg-light-gray-100">
                    <div className="flex items-center">

                        <RadioIcon
                          className={`inline mr-1`}
                          aria-hidden="true" 
                          checked={location.hash.slice(1) === node.path.slice(1)}
                        />
                        <a className="font-light no-underline" href={`#${node.path.slice(1)}`} onClick={allowScroll}>{node.label}</a>
                    </div>
                  </div>
                );
              }
            }
            return null;
          })}
        </>
      )}

    </div>

  </div>
)};

Menu.propTypes = {
  childCategories: PropTypes.array.isRequired,
  allowScroll: PropTypes.func,
  topCategoryItem: PropTypes.object.isRequired,
};

export default Menu;
